import React from 'react';

export default function Burger() {
	return (
		<g>
			<path fill="#FFCE8D" d="M84.13434,361.64685c-23.73875,0-42.98285,3.76978-42.98285,8.41995
				c0,15.16107,13.49446,23.88892,42.98285,23.88892s42.98284-8.72784,42.98284-23.88892
				C127.11718,365.41663,107.87323,361.64685,84.13434,361.64685z" />
			<path fill="#AD6636" d="M127.11726,362.00894c0-3.41483-1.84582-6.52722-4.73934-7.89487
				c-5.62027-2.65646-17.02717-6.13162-38.24351-6.13162s-32.62323,3.47516-38.24351,6.13162
				c-2.89352,1.36765-4.73934,4.48004-4.73935,7.89487c0,3.41483,1.84582,6.52722,4.73934,7.89487
				c5.62027,2.65649,17.02717,6.13165,38.24351,6.13165s32.62324-3.47516,38.24351-6.13165
				C125.27142,368.53616,127.11725,365.42377,127.11726,362.00894z" />
			<path fill="#FFCE61" d="M39.57019,355.39557c9.56087,2.13794,19.06597,6.41434,28.549,11.5275
				c12.56584-3.71191,41.57589-9.84686,62.34962-8.31848c0,0-2.99178-7.16156-19.27512-8.87753
				c-8.15985-0.85989-50.03115,0.07019-50.03115,0.07019S45.24285,348.67633,39.57019,355.39557z" />
			<path fill="#FFBB10" d="M130.46881,358.60458c-20.77374-1.52838-49.78378,3.32489-62.34962,7.0368
				c-9.48302-5.11316-18.98812-8.10788-28.549-10.24582v2.41299c9.56087,2.13791,19.06597,5.27158,28.549,10.38474
				c12.56584-3.71191,41.57589-8.70413,62.34962-7.17572V358.60458z" />
			<path fill="#75C69F" d="M129.65887,347.91803c0,2.0264-0.93916,1.9747-6.03466,3.54242
				c-2.72267,0.83768-5.2101,4.26025-9.01715,4.89087c-3.05296,0.50571-6.88684-1.81223-10.48766-1.47034
				c-3.18277,0.30215-6.29965,3.30652-9.81253,3.46057c-3.25426,0.14273-6.71087-2.56192-10.17248-2.56192
				c-3.4611,0-6.9172,2.70465-10.17101,2.56198c-3.51431-0.15408-6.63251-3.15854-9.81643-3.46088
				c-3.60055-0.34189-7.43422,1.97601-10.48693,1.47031c-3.80747-0.63077-6.29504-4.05347-9.01776-4.89133
				c-5.09402-1.56754-6.03234-1.51562-6.03234-3.54169c0-2.0264,0.93916-1.9747,6.03466-3.54242
				c2.72267-0.83768,5.2101-5.51312,9.01715-6.14374c3.05296-0.50571,6.88684,3.06509,10.48766,2.72321
				c3.18277-0.30219,6.29965-4.55939,9.81253-4.71344c3.25426-0.14273,6.71087,3.81476,10.17248,3.81476
				c3.4611,0,6.9172-3.95749,10.17101-3.81482c3.51431,0.15408,6.63251,4.41141,9.81643,4.71375
				c3.60055,0.34189,7.43422-3.22888,10.48693-2.72318c3.80747,0.63077,6.29504,5.30634,9.01776,6.14417
				C128.72055,345.94388,129.65887,345.89197,129.65887,347.91803z" />
			<path fill="#FFCE8D" d="M41.15154,341.17172c0,4.65027,19.24408,8.42007,42.98286,8.42007s42.98286-3.76981,42.98286-8.42007
				c0-23.73877-19.24409-38.19781-42.98286-38.19781S41.15154,317.43295,41.15154,341.17172z" />
			<path fill="#F8FAFF" d="M89.70567,322.57483c0.39602,0.2558,0.39602,0.83029,0,1.08609
				c-0.57935,0.37424-1.33677,0.80444-1.75725,0.80444c-0.74419,0-1.34748-0.6033-1.34748-1.34747
				c0-0.7442,0.60329-1.3475,1.34748-1.3475C88.3689,321.77039,89.12631,322.20059,89.70567,322.57483z" />
			<path fill="#F8FAFF" d="M72.43877,314.17578c-0.09914-0.46094,0.30707-0.86716,0.76799-0.76801
				c0.67429,0.14505,1.51405,0.3764,1.81138,0.67374c0.52622,0.52625,0.52622,1.37939,0,1.90564
				c-0.52622,0.52621-1.3794,0.52621-1.90562,0C72.81519,315.68982,72.58381,314.85007,72.43877,314.17578z" />
			<path fill="#F8FAFF" d="M58.39066,319.68686c-0.09914-0.46091,0.30707-0.86713,0.768-0.76797
				c0.67429,0.14502,1.51405,0.3764,1.81137,0.67374c0.52622,0.52621,0.52622,1.37939,0,1.90561
				c-0.52622,0.52625-1.3794,0.52625-1.90562,0C58.76708,321.20093,58.5357,320.36115,58.39066,319.68686z" />
			<path fill="#F8FAFF" d="M88.46361,311.70828c-0.46092,0.09915-0.86714-0.30707-0.768-0.76797
				c0.14503-0.67429,0.37642-1.51407,0.67375-1.81137c0.52622-0.52625,1.37939-0.52625,1.90562,0
				c0.52623,0.52621,0.52623,1.37939,0,1.90561C89.97765,311.33188,89.1379,311.56326,88.46361,311.70828z" />
			<path fill="#F8FAFF" d="M101.31787,317.88849c-0.25582,0.39603-0.83029,0.39603-1.08611,0
				c-0.37424-0.57935-0.80443-1.33676-0.80443-1.75723c0-0.7442,0.60329-1.3475,1.34748-1.3475
				c0.74419,0,1.34747,0.6033,1.34747,1.3475C102.12229,316.55173,101.69211,317.30914,101.31787,317.88849z" />
			<path fill="#F8FAFF" d="M111.51496,314.79657c-0.25581,0.39603-0.83029,0.39603-1.08611,0
				c-0.37424-0.57935-0.80443-1.33676-0.80443-1.75723c0-0.7442,0.60329-1.34747,1.34748-1.34747s1.34748,0.60327,1.34748,1.34747
				C112.31939,313.45981,111.88921,314.21722,111.51496,314.79657z" />
			<path fill="#F8FAFF" d="M79.54465,306.07864c-0.25581,0.39603-0.83029,0.39603-1.08611,0
				c-0.37424-0.57935-0.80443-1.33676-0.80443-1.75723c0-0.7442,0.60329-1.3475,1.34748-1.3475s1.34748,0.6033,1.34748,1.3475
				C80.34908,304.74188,79.91889,305.4993,79.54465,306.07864z" />
			<path fill="#F8FAFF" d="M99.29466,307.77951c-0.25581,0.39603-0.83029,0.39603-1.08611,0
				c-0.37424-0.57935-0.80443-1.33676-0.80443-1.75723c0-0.7442,0.60329-1.34747,1.34748-1.34747s1.34748,0.60327,1.34748,1.34747
				C100.09909,306.44275,99.66891,307.20016,99.29466,307.77951z" />
			<path fill="#F8FAFF" d="M64.10948,311.40256c-0.25582,0.39603-0.8303,0.39603-1.08611,0
				c-0.37424-0.57935-0.80442-1.33676-0.80442-1.75723c0-0.7442,0.60329-1.34747,1.34748-1.34747
				c0.74419,0,1.34748,0.60327,1.34748,1.34747C64.9139,310.0658,64.48372,310.82321,64.10948,311.40256z" />
		</g>
	);
}



// WEBPACK FOOTER //
// ./src/components/Global/Goodies/Toy/Burger.js